import { Injectable } from '@angular/core';
import { select, Selection, BaseType, area, curveLinear, ScaleLinear } from 'd3';
import { CvdChartData, CvdBandDataValue, CvdChartDataValue } from '@covance/ng-cvd3';
import { isEmpty } from 'lodash';
import { LabTestResult } from '../lab-test-results';

@Injectable()
export class BandRenderer {
    
     public initHovers(svgId: string, xScale: ScaleLinear<number, number>, yScale: ScaleLinear<number, number>, resultsDictionary: { [labTestId: number]: LabTestResult }) {     
        const bands = select(`#${svgId}`).selectAll<SVGElement, CvdChartData<CvdBandDataValue>>('.cv-stackedarea .cv-group');
        bands.attr('opacity', '.25');
        bands.attr('visibility', 'hidden');

        const pointsWithRange = select(`#${svgId}`)
            .selectAll('.cv-point')
            .filter((p: CvdChartData<CvdBandDataValue>) => {
                if (isEmpty(p.rows)) {
                    return false;
                }
                return !!resultsDictionary[p.rows[0]].currentResult.range;
            });
        pointsWithRange.on('mouseover', (data: CvdChartDataValue) => {
            const currentBand = bands.filter((el, i) => i === data.series);
            
            this.extendBands(currentBand, xScale, yScale);
            currentBand.attr('visibility', 'visible');
        });
        pointsWithRange.on('mouseleave', () => {
            bands.attr('visibility', 'hidden');
        });
    }

    private valueToNumber(value: number): number {
        return isNaN(value) ? 0 : value;
    }

    private extendBands(bands: Selection<SVGElement, CvdChartData<CvdBandDataValue>, BaseType, any>, xScale: ScaleLinear<number, number>, yScale: ScaleLinear<number, number>) {
        const xDomain = xScale.domain();

        bands
            .select('path')
            .attr('d', dd => {
                if (!isEmpty(dd.values)) {
                    const left = {...dd.values[0], x: xDomain[0] };
                    const right = {...dd.values[dd.values.length - 1], x: xDomain[xDomain.length - 1] };
                    dd.values.unshift(left);
                    dd.values.push(right);
                }

                const band = area<CvdBandDataValue>().curve(curveLinear)
                    .x(d => {
                        return this.valueToNumber(xScale(d.x as number));
                    })
                    .y0(d => {
                        return this.valueToNumber(yScale(d.y1 as number));
                    })
                    .y1(d => {
                        return this.valueToNumber(yScale(d.y2 as number));
                    });

                const dValue = band(dd.values);

                return dValue;
            });
    }
}